
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import PlatformMarkerStack1 from "../../editor/platform-markers/cave/PlatformMarkerStack1";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import PlatformMarkerStack3 from "../../editor/platform-markers/cave/PlatformMarkerStack3";
import TrapMarkerTorch from "../../editor/trap-markers/cave/TrapMarkerTorch";
import PlatformMarkerPlatMini from "../../editor/platform-markers/cave/PlatformMarkerPlatMini";
import MoverData from "../../../components/platformer/MoverData";
import PlatformMarkerPillar from "../../editor/platform-markers/cave/PlatformMarkerPillar";
import PlatformMarkerStack2 from "../../editor/platform-markers/cave/PlatformMarkerStack2";
import PlatformMarkerPlatMid from "../../editor/platform-markers/cave/PlatformMarkerPlatMid";
import PlatformMarkerGroundLava from "../../editor/platform-markers/cave/PlatformMarkerGroundLava";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import PlatformMarkerPlat from "../../editor/platform-markers/cave/PlatformMarkerPlat";
import PositionMarker from "../../editor/PositionMarker";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class CaveChunk2 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? -381.58257912127925, y ?? 178.22467347422582);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 233, 368);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 6305, 368);
    this.add(editor_bounds_right);

    // platformMarkerStack_1
    const platformMarkerStack_1 = new PlatformMarkerStack1(scene, 3005, 324);
    this.add(platformMarkerStack_1);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 1934, -180);
    this.add(gemMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 2401, 114);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 2265, 117);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 2528, 117);
    this.add(gemMarker_3);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 1568, -87);
    this.add(gemMarker_12);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 3627, 244);
    this.add(gemMarker_13);

    // platformMarkerStack_12
    const platformMarkerStack_12 = new PlatformMarkerStack3(scene, 5677, 288);
    this.add(platformMarkerStack_12);

    // platformMarkerStack_13
    const platformMarkerStack_13 = new PlatformMarkerStack3(scene, 5930, 284);
    this.add(platformMarkerStack_13);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 3187, -456);
    this.add(gemMarker_14);

    // gemMarker_15
    const gemMarker_15 = new SmallGemMarker(scene, 3919, 9);
    this.add(gemMarker_15);

    // gemMarker_16
    const gemMarker_16 = new SmallGemMarker(scene, 3533, 244);
    this.add(gemMarker_16);

    // trapMarkerTorch_6
    const trapMarkerTorch_6 = new TrapMarkerTorch(scene, 3911, -469);
    this.add(trapMarkerTorch_6);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 2368, -225);
    this.add(gemMarker_4);

    // gemMarker_17
    const gemMarker_17 = new SmallGemMarker(scene, 2777, -345);
    this.add(gemMarker_17);

    // gemMarker_18
    const gemMarker_18 = new SmallGemMarker(scene, 1188, 164);
    this.add(gemMarker_18);

    // gemMarker_21
    const gemMarker_21 = new SmallGemMarker(scene, 3430, 244);
    this.add(gemMarker_21);

    // gemMarker_24
    const gemMarker_24 = new SmallGemMarker(scene, 3000, 240);
    this.add(gemMarker_24);

    // gemMarker_25
    const gemMarker_25 = new SmallGemMarker(scene, 4236, -134);
    this.add(gemMarker_25);

    // gemMarker_26
    const gemMarker_26 = new SmallGemMarker(scene, 5796, 88);
    this.add(gemMarker_26);

    // gemMarker_27
    const gemMarker_27 = new SmallGemMarker(scene, 5274, -183);
    this.add(gemMarker_27);

    // platformMarkerPlatMini
    const platformMarkerPlatMini = new PlatformMarkerPlatMini(scene, 1567, -16);
    this.add(platformMarkerPlatMini);

    // platformMarkerPlatMini_1
    const platformMarkerPlatMini_1 = new PlatformMarkerPlatMini(scene, 1936, -109);
    this.add(platformMarkerPlatMini_1);

    // platformMarkerPlatMini_2
    const platformMarkerPlatMini_2 = new PlatformMarkerPlatMini(scene, 2305, -128);
    this.add(platformMarkerPlatMini_2);

    // platformMarkerPillar_2
    const platformMarkerPillar_2 = new PlatformMarkerPillar(scene, 1193, 287);
    this.add(platformMarkerPillar_2);

    // platformMarkerStack2
    const platformMarkerStack2 = new PlatformMarkerStack2(scene, 2204, 290);
    this.add(platformMarkerStack2);

    // platformMarkerStack
    const platformMarkerStack = new PlatformMarkerStack2(scene, 2576, 290);
    this.add(platformMarkerStack);

    // platformMarkerPlatMid_1
    const platformMarkerPlatMid_1 = new PlatformMarkerPlatMid(scene, 2392, 204);
    this.add(platformMarkerPlatMid_1);

    // platformMarkerGroundLava
    const platformMarkerGroundLava = new PlatformMarkerGroundLava(scene, 3520, 318);
    this.add(platformMarkerGroundLava);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 4157, -452);
    this.add(megaGemMarker_2);

    // platformMarkerPlatMini_3
    const platformMarkerPlatMini_3 = new PlatformMarkerPlatMini(scene, 3652, -377);
    this.add(platformMarkerPlatMini_3);

    // platformMarkerPlatMini_4
    const platformMarkerPlatMini_4 = new PlatformMarkerPlatMini(scene, 3905, -379);
    this.add(platformMarkerPlatMini_4);

    // platformMarkerPlatMini_5
    const platformMarkerPlatMini_5 = new PlatformMarkerPlatMini(scene, 4154, -377);
    this.add(platformMarkerPlatMini_5);

    // gemMarker_29
    const gemMarker_29 = new SmallGemMarker(scene, 4642, -52);
    this.add(gemMarker_29);

    // platformMarkerPlat_2
    const platformMarkerPlat_2 = new PlatformMarkerPlat(scene, 4637, 26);
    this.add(platformMarkerPlat_2);

    // platformMarkerPlatMid_3
    const platformMarkerPlatMid_3 = new PlatformMarkerPlatMid(scene, 4745, -241);
    this.add(platformMarkerPlatMid_3);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 3656, -453);
    this.add(megaGemMarker);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 4730, -311);
    this.add(megaGemMarker_1);

    // platformMarkerPlat_3
    const platformMarkerPlat_3 = new PlatformMarkerPlat(scene, 5283, -97);
    this.add(platformMarkerPlat_3);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 488, 131);
    this.add(gemMarker_5);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 365, 134);
    this.add(gemMarker_6);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 628, 134);
    this.add(gemMarker_7);

    // platformMarkerStack_2
    const platformMarkerStack_2 = new PlatformMarkerStack2(scene, 304, 307);
    this.add(platformMarkerStack_2);

    // platformMarkerStack_3
    const platformMarkerStack_3 = new PlatformMarkerStack2(scene, 676, 307);
    this.add(platformMarkerStack_3);

    // platformMarkerPlatMid_4
    const platformMarkerPlatMid_4 = new PlatformMarkerPlatMid(scene, 492, 221);
    this.add(platformMarkerPlatMid_4);

    // positionMarker
    const positionMarker = new PositionMarker(scene, 2307, -129);
    this.add(positionMarker);

    // positionMarker_1
    const positionMarker_1 = new PositionMarker(scene, 2437, -130);
    this.add(positionMarker_1);

    // platformMarkerPlatMini_6
    const platformMarkerPlatMini_6 = new PlatformMarkerPlatMini(scene, 3127, -370);
    this.add(platformMarkerPlatMini_6);

    // positionMarker_2
    const positionMarker_2 = new PositionMarker(scene, 3129, -371);
    this.add(positionMarker_2);

    // positionMarker_3
    const positionMarker_3 = new PositionMarker(scene, 3259, -372);
    this.add(positionMarker_3);

    // platformMarkerPlatMini_7
    const platformMarkerPlatMini_7 = new PlatformMarkerPlatMini(scene, 2775, -267);
    this.add(platformMarkerPlatMini_7);

    // platformMarkerPlatMini_8
    const platformMarkerPlatMini_8 = new PlatformMarkerPlatMini(scene, 3916, 79);
    this.add(platformMarkerPlatMini_8);

    // platformMarkerPlatMini_9
    const platformMarkerPlatMini_9 = new PlatformMarkerPlatMini(scene, 4235, -60);
    this.add(platformMarkerPlatMini_9);

    // platformMarkerPlat_4
    const platformMarkerPlat_4 = new PlatformMarkerPlat(scene, 5799, 172);
    this.add(platformMarkerPlat_4);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 363, 183);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 2261, 163);
    this.add(checkpointMarker_1);

    // checkpointMarker_2
    const checkpointMarker_2 = new CheckpointMarker(scene, 3425, 280);
    this.add(checkpointMarker_2);

    // checkpointMarker_3
    const checkpointMarker_3 = new CheckpointMarker(scene, 5737, 129);
    this.add(checkpointMarker_3);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    // platformMarkerPlatMini_2 (components)
    const platformMarkerPlatMini_2MoverData = new MoverData(platformMarkerPlatMini_2);
    platformMarkerPlatMini_2MoverData.startMarker = positionMarker;
    platformMarkerPlatMini_2MoverData.endMarker = positionMarker_1;
    platformMarkerPlatMini_2MoverData.startWait = 500;

    // platformMarkerPlatMini_6 (components)
    const platformMarkerPlatMini_6MoverData = new MoverData(platformMarkerPlatMini_6);
    platformMarkerPlatMini_6MoverData.startMarker = positionMarker_2;
    platformMarkerPlatMini_6MoverData.endMarker = positionMarker_3;
    platformMarkerPlatMini_6MoverData.startWait = 500;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
